import React from 'react'
import { CodeWidgetCheck } from '../widgets/CodeWidget/analysis/use-code-widget-check'
import { PublishCheck, toPublishCheck } from './publish-check'

/** The Lock&Publish view of the shared Code Widget scan, so the topbar colour follows every edit. */
export function usePublishCheck(check: CodeWidgetCheck): PublishCheck {
  return React.useMemo(() => toPublishCheck(check), [check])
}
